import * as React from 'react';
import { NavLink, useLocation } from "react-router-dom";

import HomeIcon from '../assets/icons/HomeIcon';
import AccountIcon from '../assets/icons/AccountIcon';
import PostIcon from '../assets/icons/PostIcon';
import EventIcon from '../assets/icons/EventIcon';

function  MenuItem() {
    return (
        

        <div className="fixed bottom-0 left-0 z-40 w-full h-16 bg-white border-t border-gray-200 dark:bg-gray-700 dark:border-gray-600">
            <div className="grid h-full max-w-lg grid-cols-4 mx-auto my-auto">
                <NavLink to="/" >
                    <button type="button" className="py-3 inline-flex flex-col items-center justify-center px-5 hover:bg-gray-50 dark:hover:bg-gray-800 group">
                        <HomeIcon size={'2.5em'} stokeWidth={1} color={ useLocation().pathname === '/' ? 'black' : '#B6B6B6'}/>
                    </button>
                </NavLink>
                <NavLink to="/post">
                <button type="button" className="py-3 inline-flex flex-col items-center justify-center px-5 hover:bg-gray-50 dark:hover:bg-gray-800 group">
                    <PostIcon size={'2.5em'} stokeWidth={0.1} color={ useLocation().pathname === '/post' ? 'black' : '#B6B6B6' }/>
                </button>
                </NavLink>
                <NavLink to="/event">
                <button type="button" className="py-3 inline-flex flex-col items-center justify-center px-5 hover:bg-gray-50 dark:hover:bg-gray-800 group">
                    <EventIcon size={'2.5em'} stokeWidth={0.1} color={ useLocation().pathname === '/event' ? 'black' : '#B6B6B6' }/>
                </button>
                </NavLink>
                <NavLink to="/profile">
                <button type="button" className="py-3 inline-flex flex-col items-center justify-center px-5 hover:bg-gray-50 dark:hover:bg-gray-800 group">
                    <AccountIcon size={'2.5em'} stokeWidth={0.1} color={ useLocation().pathname === '/profile' ? 'black' : '#B6B6B6' }/>
                </button>
                </NavLink>
            </div>
        </div>
    )
}

export default MenuItem;